import { render, staticRenderFns } from "./m-shared-icons.vue?vue&type=template&id=22ada328&scoped=true&lang=pug"
import script from "./m-shared-icons.vue?vue&type=script&lang=js"
export * from "./m-shared-icons.vue?vue&type=script&lang=js"
import style0 from "./m-shared-icons.vue?vue&type=style&index=0&id=22ada328&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22ada328",
  null
  
)

export default component.exports